import { HotelService } from "@/types/hotelService";
import {
  CreateHotelServiceFormData,
  mapServiceDisplaySettingsToForm,
  mergeServiceDisplaySettings,
} from "./serviceSchema";

export const mapServiceToFormData = (
  service: HotelService,
): CreateHotelServiceFormData => ({
  ...(Object.fromEntries(
    Object.entries(service).filter(
      ([key, value]) =>
        (typeof value === "boolean" || !!value) &&
        key !== "contractor" &&
        key !== "checkinAvailable" &&
        key !== "checkoutAvailable" &&
        key !== "displaySettings",
    ),
  ) as CreateHotelServiceFormData),
  autoCreateTriggers: service.autoCreateTriggers ?? [],
  ...(service.price && { price: service.price?.toString() }),
  ...(service.discount && { discount: service.discount?.toString() }),
  ...(service.contractor && {
    contractor: {
      ...service.contractor,
      fee: service.contractor.fee?.toString(),
    },
  }),
  serviceDisplaySettings: service.displaySettings
    ? mapServiceDisplaySettingsToForm(service.displaySettings)
    : mergeServiceDisplaySettings({
        checkInCheckOut: {
          preCheckIn: service.checkinAvailable,
          inHouse: false,
          preCheckOut: service.checkoutAvailable,
        },
      }),
});
